@import 'styles/mixins';
@import 'styles/variables';

.avatar {
  position: relative;
  padding: 4px 10px 4px 6px;

  .icon {
    position: absolute;
    bottom: 0;
    right: 3px;
  }
}
